import {createFileRoute} from '@tanstack/react-router';
import TasteAdminPage from '@features/admin/taste/page';

export const Route = createFileRoute('/admin/taste')({
  component: function TastePage() {
    return (
      <>
        <title>Banani | Taste</title>
        <TasteAdminPage />
      </>
    );
  },
});
